import Caption from './Caption/Caption';
import Coach from './Coach/Coach';
import { DisplayElement } from '@app/common';
import Image from './Image/Image';
import Text from './Text/Text';
import Video from './Video/Video';
import Youtube from './Youtube/Youtube';
import Audio from './Audio/Audio';
import InfoTerm from './InfoTerm/InfoTerm';
import Listing from './Listing/Listing';

type Properties = {
    element: DisplayElement,
};

const DisplayElementRenderer = (props: Properties) => {
    const getElement = () => {
        switch (props.element.type) {
            case 'caption':
                return (
                    <Caption data={props.element} />
                );
            case 'listing':
                return (
                    <Listing data={props.element} />
                );
            case 'coach':
                return (
                    <Coach data={props.element} />
                );
            case 'image':
                return (
                    <Image data={props.element} />
                );
            case 'text':
                return (
                    <Text data={props.element} />
                );
            case 'youtube':
                return (
                    <Youtube data={props.element} />
                );
            case 'video':
                return (
                    <Video data={props.element} />
                );
            case 'audio':
                return (
                    <Audio data={props.element} />
                );
            case 'info_term':
                return (
                    <InfoTerm data={props.element} />
                );
            default: return <div>Element not supported by DisplayElementsRenderer</div>;
        }
    };

    return (
        <>{getElement()}</>
    );
};

export default DisplayElementRenderer;